module.exports = __webpack_public_path__ + "sinatra.83f083.svg";